import {
  Checkbox,
  DatePicker,
  Field,
  Select
} from '../../../../react-final-form-wrappers'
import FormRow from '../../FormRow'
import { client } from '../../../../client'
import { TextField } from 'mui-rff'
import { useField, useFormState } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { FilesSection } from '../FilesSection'
import Button from '@material-ui/core/Button'
import { AlertDialog } from '../../../../components/AlertDialog'
import Alert from '@material-ui/lab/Alert'
import EndLetterTemplate from './EndLetterTemplate'

const EndTreatmentProgramSection = () => {
  const { t } = useTranslation('endTreatmentSection')
  const { t: tStart } = useTranslation('startTreatmentProgramSection')

  const {
    input: { value: isLegacy }
  } = useField('isLegacy')

  const {
    input: { value: programId }
  } = useField('id')

  const program = useFormState().values

  const missingFields = Object.values({
    primaryPsychologist: program?.primaryPsychologist ? '' : tStart('primaryPsychologist'),
    patientFirstName: program?.patient?.firstName ? '' : tStart('firstName'),
    patientLastName: program?.patient?.lastName ? '' : tStart('lastName'),
    birthDate: program?.patient?.birthDate ? '' : tStart('birthDate'),
    gender: program?.patient?.gender ? '' : tStart('gender'),
    street: program?.patient?.street ? '' : tStart('street'),
    postalCode: program?.patient?.postalCode ? '' : tStart('postalCode'),
    residence: program?.patient?.residence ? '' : tStart('residence'),
    houseNumber: program?.patient?.houseNumber ? '' : tStart('houseNumber'),
    bsn: program?.patient?.bsn ? '' : tStart('bsn'),
    startDate: program?.startDate ? '' : tStart('startDateLabel'),
    practice: program?.practice ? '' : tStart('practice'),
    language: program?.funnel?.language ? '' : tStart('language'),
    location: (program?.funnel?.online || program?.funnel?.onsite) ? '' : tStart('location')
  })
    .filter((field) => !!field)
    .join(', ')

  return (
    <>
      {isLegacy && (
        <FormRow>
          <Select
            style={{ width: 500 }}
            label={t('performanceLabel')}
            getOptions={async (): Promise<any[]> => client.getProductOptions()}
            getOptionLabel={(i: any) => i.name}
            getOptionValue={(i: any) => i.id}
            name="productEnd.id"
          />
        </FormRow>
      )}
      <FormRow>
        <Field
          name="cqiSent"
          label={`Evaluatie ${t('sent')}`}
          type="checkbox"
          component={Checkbox}
        />
      </FormRow>
      {(program?.practice?.name !== 'Mulder & Van Schie' ||
        !!program?.endIsiScore ||
        !!program?.endIsiSent) && (
        <>
          <FormRow>
            <Field
              name="endIsiSent"
              label={`ISI ${t('endSent')}`}
              type="checkbox"
              component={Checkbox}
            />
          </FormRow>
          <FormRow>
            <TextField
              name="endIsiScore"
              label={`ISI-score (${t('endMeasurement')})`}
            />
          </FormRow>
        </>
      )}
      <FormRow>
        <Field
          style={{ width: 300 }}
          name="endDate"
          label={t('endDateLabel')}
          component={DatePicker}
        />
      </FormRow>
      <FormRow>
        <Select
          style={{ width: 300 }}
          label={t('lastStep')}
          getOptions={async (): Promise<any[]> =>
            isLegacy
              ? client.getClosingReasonOptions()
              : client.getClosingReasonOptions(false)
          }
          getOptionLabel={(i: any) => i.name}
          getOptionValue={(i: any) => i.id}
          name="closingReason.id"
        />
      </FormRow>

      {missingFields && (
        <Alert severity="warning">
          {tStart('missingFieldsWarning')} {missingFields}.
        </Alert>
      )}

      {/* @ts-ignore content accepts ReactNode in implementation */}
      <AlertDialog
        fullWidth
        maxWidth={false}
        content={<EndLetterTemplate programId={programId} />}
        title={t('alertTitle')}
        confirmText={t('confirmText')}
        // @ts-ignore content accepts ReactNode in implementation
        render={({ onClick }: { onClick: () => void }) => (
          <Button
            disabled={!!missingFields}
            onClick={onClick}
            type="button"
            color="primary"
          >
            {t('alertTitle')}
          </Button>
        )}
      />

      <FormRow>
        <FilesSection
          uploadedFileType={'endLetter'}
          typesToShow={['endLetter']}
        />
      </FormRow>
    </>
  )
}

export default EndTreatmentProgramSection
